import {
  ADD_QUESTIONNAIRE,
  EDIT_QUESTIONNAIRE,
  LIST_QUESTIONNAIRE,
  VIEW_QUESTIONNAIRE,
  DELETE_QUESTIONNAIRE,
  // text
  ADD_QUESTIONNAIRE_TEXT,
  EDIT_QUESTIONNAIRE_TEXT,
  LIST_QUESTIONNAIRE_TEXT,
  VIEW_QUESTIONNAIRE_TEXT,
  DELETE_QUESTIONNAIRE_TEXT,
  QUESTIONNAIRE_SUCCESS,
  QUESTIONNAIRE_ERROR,

} from "./actionTypes"

// add aspiration question
export const addQuestionnaire = (data, history, callback) => {
  return {
    type: ADD_QUESTIONNAIRE,
    payload: { data, history, callback }
  }
}

// edit aspiration question
export const editQuestionnaire = (data, id, callback) => {
  return {
    type: EDIT_QUESTIONNAIRE,
    payload: { data, id, callback },
  }
}

// list aspiration question
export const listQuestionnaire = (data, callback) => {
  return {
    type: LIST_QUESTIONNAIRE,
    payload: { data, callback },
  }
}

// view aspiration question
export const viewQuestionnaire = (data, history) => {
  return {
    type: VIEW_QUESTIONNAIRE,
    payload: { data, history },
  }
}

// delete aspiration question
export const deleteQuestionnaire = (data, callback) => {
  return {
    type: DELETE_QUESTIONNAIRE,
    payload: { data, callback },
  }
}

// text
// add questionnaire
export const addQuestionnaireText = (data, history, callback) => {
  return {
    type: ADD_QUESTIONNAIRE_TEXT,
    payload: { data, history, callback }
  }
}

// edit questionnaire
export const editQuestionnaireText = (data, id, callback) => {
  return {
    type: EDIT_QUESTIONNAIRE_TEXT,
    payload: { data, id, callback },
  }
}

// list questionnaire
export const listQuestionnaireText = (data, id, callback) => {
  return {
    type: LIST_QUESTIONNAIRE_TEXT,
    payload: { data, id, callback },
  }
}

// view questionnaire
export const viewQuestionnaireText = (data, history) => {
  return {
    type: VIEW_QUESTIONNAIRE_TEXT,
    payload: { data, history },
  }
}

// delete questionnaire
export const deleteQuestionnaireText = (data, callback) => {
  return {
    type: DELETE_QUESTIONNAIRE_TEXT,
    payload: { data, callback },
  }
}

export const questionnaireSuccess = message => {
  return {
    type: QUESTIONNAIRE_SUCCESS,
    payload: message,
  }
}

export const questionnaireError = message => {
  return {
    type: QUESTIONNAIRE_ERROR,
    payload: message,
  }
}
